/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/
export default {
  'standard': {
    '用户不存在': 'このアカウントは登録されていません。登録してからログインしてください	',
    'no_zone_code': '(国番号不要)',
    '授权校验失败，请刷新页面并重试。': 'Authorization verification failed. Please refresh the page and try again.',
    'onlineService': 'Online service',
    'standardExpress': 'スタンダードエクスプレス',
    'economyExpress': 'エコノミーエクスプレス',
    'eParcel': 'Eパーセルサービス',
    'overseasFulfilment': '国際EC特別郵便',
    'warehouse': '海外倉庫サービス',
    'pleaseAgreePolicy': 'Please read and agree to the Privacy Policy',
    'pleaseAgreeToScan': 'まず右側の利用規約を読んで同意してください',
    'heavyFreight': '国際重貨',
    '验证码接收方式': '認証コードの受け取り方',
    'cancelTips': 'アカウントの解除通知をお読みの上、同意してください',
    'confirmCancel': '取り消しを確認する',
    'verificationCodeError': '認証コードエラー、認証コードを再取得してください！',
    'clickGoDirectly': '（クリックして直接行く）',
    'repeatTips': 'アカウントに重複する問題があります。<span class="mode">ログイン方法を選択してログインしてください。{count}秒後に自動的にジャンプします',
    'repeatTips1': '携帯電話番号に重複する問題があります。<span class="mode">セクション番号</span>を選択してログインしてください。{count}秒後に自動的にジャンプします',
    'goOldLogin': '旧バージョンのログイン',
    'goNewLogin': '新規ログイン',
    'siteTips': 'システムエクスペリエンスを向上させるために、別の国または地域に切り替えることを選択できます',
    'siteGo': 'に行く',
    'loginLoading': '新しいシステムにログインしています。少々お待ちください。',
    'sfExpress': '順豊速運版権所有広東ICP備08034243号',
    'sgSfExpress': '順豊速運版権所有広東ICP備08034243号',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': '国際認証サービスセンター',
    'jumpError': 'ジャンプアドレスが不正です',
    'tips': '注意',
    'tips1': '注意',
    'confirm': '確認',
    'agreeWith': 'I have read and agree to the ',
    'agreeAndContinue': '私は「個人情報の取り扱いについて」を読んで同意しました',
    'agreeService': 'サービス条項を読んで同意しました',
    'agreeUserAgreement': 'ユーザー・プロトコルを読んで同意しました',
    'agreeEpesAcceptableUse': '私は「SF Korea ERP 利用規約」を読んで同意しました',
    'define': '確定',
    'cancel': 'キャンセル',
    'yes': 'はい',
    'no': 'いいえ',
    'sendAgain': '再送信',
    'second': '秒',
    'iknow': 'クローズ',
    'country': '国/地域',
    'tel': '電話番号',
    'email': 'メールアドレス',
    'telNumber': '携帯番号',
    'verifyCode': '認証コード',
    'sendVerificationCode': '認証コードの送信',
    'next': '次のステップ',
    'prev': '前',
    'finished': '完成',
    'back': '戻る',
    'backLogin': 'ログイン画面に戻る',
    'home': 'インターナショナルオフィシャルサイト',
    'home_os': 'KEX Express',
    'inquiry': '検索',
    'add': '新規',
    'edit': '編集',
    'del': '削除',
    'batchDel': '一括削除',
    'operating': '操作',
    'clearInfo': '情報を空欄にクリアする',
    'excelUpload': 'Excelのアップロード',
    'serialNumber': '番号',
    'save': '保存',
    'leastOne': '削除するデータを確認してください',
    'uploadFile': 'ファイルアップロード',
    'downloadExcel': 'EXCELテンプレートをダウンロードする',
    'pleaseInput': '入力してください',
    'pleaseSelect': '選択してください',
    'isDel': '選択したデータを削除しますか？',
    'agree': '承諾',
    'disagree': '取消',
    'uploadTotal': 'アップロードの総数',
    'uploadSuccess': '成功したアップロード',
    'uploadFail': 'アップロード失敗',
    'checkAll': 'すべてを選択',
    'cancelContent': 'アカウントのキャンセルは[{cancelTime}]でログアウトのために送信され、15日以内にログインすると再びアクティブになります。ログインを続行しますか？',
    'ok': 'はい',
    'autoTip': '認証中です、お待ちください…',
    'feedback': '機能フィードバック/推奨事項',
    'scanCode': 'スキャンログイン',
    'useWxScan': '微信スキャンを使用する',
    'useWhatsAppScan': 'WhatsAppスキャンを使用する',
    'otherLoginWays': 'その他のログイン方法',
    'scanSuccessfully': 'スキャンコード成功',
    'confirmOnPhone': '携帯電話でご確認ください',
    'refreshQR': 'クリックして更新',
    'consult': '法人アカウント開設',
    'please_select_correct_phone': '正しい携帯電話番号を選択してください',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'gls',
    'gls_tooltip': 'ツールチップ'
  },
  'login': {
    'toLogin': 'ログインに行く',
    'account': 'アカウント',
    'accountRepeativeTitle': 'アカウントの繰り返し処理',
    'accountRepeativeDesc': 'あなたのアカウントは重複しています。どのアカウントでシステムにログインするかを確認する必要があります。ログイン後にアカウントの1つをログアウトしたり、縛ったりすることもでき、後続に同じような状況が二度と起こらないようにすることもできます。',
    'accountType': 'アカウントタイプ',
    'aciton': '操作',
    'merge': 'Three element fusion version',
    'unique': 'Three element independent version',
    'selectLoginType': 'ログイン方法を選択',
    'personal': '個人ログイン',
    'enterprise': '法人ログイン',
    'tel': '電話番号',
    'password': 'パスワード',
    'verificationCodeLogin': '認証コードログイン',
    'verificationCode': '認証コード',
    'obtainVerificationCode': '確認コードを送信',
    'passwordLogin': 'パスワードログイン',
    'rememberPSD': '記憶する',
    'rememberTips': 'パブリックデバイスを選択することをお勧めしません',
    'forgetPSD': 'パスワードリセット',
    'loginAgree': 'に同意します',
    'agreeTips': 'プライバシーポリシー',
    'epesAcceptableUse': 'SF Korea ERP 利用規約',
    'userAgreement': '『ユーザープロトコル』',
    'login': 'ログイン',
    'username': 'ユーザー名',
    'email': 'メールアドレス',
    'phoneLogin': '携帯でログイン',
    'usernameLogin': 'ユーザー名でログイン',
    'emailLogin': 'メールアドレスでログイン',
    'usernameOrEmailLogin': 'ユーザー名/メールログイン',
    'registerNow': '今すぐ登録',
    'pleaseInput': '',
    'and': 'と',
    'sfbuy_privacy': '《SFBuy Service Agreement(Chinese Mainland)》、《SFBuy Service Agreement(International/HK, MO and TW of China)》',
    'sfbuy_title': 'SFBuy',
    'aboutUs': '私たちについて',
    'serviceGuide': '初心者向けガイド',
    'helpCenter': 'ヘルプセンター',
    'serviceAndPrice': 'サービスと価格',
    'onlineCSR': 'オンラインカスタマーサービス',
    'copyright': "Copyright ©2023順豊速運著作権所有'"
  },
  'register': {
    'personal': '個人ユーザ登録',
    'enterprise': '法人ユーザ登録',
    'tel': '電話番号',
    'telVerificationCode': '携帯認証コード',
    'email': 'メールアドレス',
    'emailVerificationCode': 'メール認証コード',
    'sendVerificationCode': '認証コードの送信',
    'password': 'パスワードを入力する',
    'passwordAgain': 'パスワードを再入力してください',
    'agree': '同意しました',
    'termsOfService': '利用規約',
    'SFBuyService': 'SFBUYサービス契約',
    'and': 'と',
    'privacyPolicy': 'プライバシーポリシー',
    'agreeTermsOfService': '利用規約に同意します',
    'agreePrivacyPolicy': 'プライバシーポリシーに同意します',
    'registerNow': '今すぐ登録',
    'haveUserName': '既にアカウントお持ちですか？',
    'loginNow': 'すぐにログイン',
    'toEmail': 'メールアドレスで登録',
    'toTel': '携帯番号で登録',
    'invitationCode': '招待コード',
    'timeCount': '（残りの{count}s、最後まで読んでください）',
    'readBottom': '（末尾までお読みください）',
    'isFinshRead': '条項情報を読んで同意してください',
    sfbuy_policy1: '《SFBuy Service Agreement(Chinese Mainland)	》',
    sfbuy_policy2: '《SFBuy Service Agreement(International/HK, MO and TW of China)	》'
  },
  'resetPassword': {
    'resetTel': '携帯電話でのリセット',
    'resetEmail': 'Eメールでのリセット',
    'tel': '電話番号',
    'telVerificationCode': '携帯認証コード',
    'email': 'メールアドレス',
    'emailVerificationCode': 'メール認証コード',
    'sendVerificationCode': '認証コードの送信',
    'newPassword': '新しいパスワード',
    'confirmNewPassword': '新しいパスワードの確認',
    'resetPassword': 'パスワードを再設定する',
    'back': '戻る',
    'login': 'ログイン',
    'register': '登録'
  },
  'modifyPassword': {
    'changePassword': 'パスワードを変更する',
    'old': '以前のパスワード',
    'new': '新しいパスワード',
    'confirm': '新しいパスワードの確認'
  },
  'cookies': {
    'tip1': '弊社のウェブサイトは、ユーザーエクスペリエンスを分析し、最適化するために、クッキーを使用しています。我々は我々の分析のパートナーとあなたの情報を共有することがあります。',
    'tip2': '「Cookieポリシー」',
    'tip3': 'より多くの情報を提供します。 設定を変更するには、をクリックしてください。',
    'tip4': 'ここに',
    'tip5': '[同意する]をクリックすると、設定に基づいてCookieを使用することに同意したことになります。',
    'disAgree': '拒否',
    'cookieSet': 'Cookieの設定',
    'preference': 'お気に入りカテゴリ',
    'optimisation': '最適化クラス',
    'analytics': '分析クラス',
    'neddCheck': 'お好みのカテゴリをチェックしてください。',
    'cookie': 'Cookieポリシー',
    'agree': '承諾',
    'preferenceCenter': 'せんこうちゅうしん'
  },
  'slideCircus': {
    'title': '下記の認証パズルを完成してください',
    'change': '変更',
    'right': 'スライダーを押したまま右にドラッグしてパズルを完成させてください',
    'pass': '認証しました',
    'verifyText': 'ボタンをクリックして確認してください',
    'verifying': 'パズル認証中',
    'loading': '画像を読み込み中'
  },
  'message': {
    'slideError': 'Slider service request failed',
    'selectTerms': '利用規約を確認してチェックを入れてください',
    'verifyPass': 'ボタンをクリックして検証してください',
    'registerSuccess': '登録完了',
    'sendTips0': '送信されました',
    'resetPasswordTips0': 'パスワードがリセット成功',
    'loginTips0': 'ログイン成功',
    'loginTips1': 'ログインに成功し、アカウントがアクティブ化されました',
    'modifiedTips0': '変更されました',
    'switchLanguage': '言語が切り替えられました',
    'switchSite': '国の切り替えに成功しました',
    'changeTel': 'お使いの携帯電話は変更されました。もう一度ログインしてください。',
    'ChangeEmail': 'メールは変更されました。もう一度ログインしてください。',
    'cancelSuccess': 'アカウントは削除されました。',
    'imgType': '画像を再選択してください。画像はJPGおよびPNG形式のアップロードのみをサポートしています。',
    'imgSize': '画像を再選択してください。画像サイズは3MBを超えることはできません。',
    'submitSuccess': '送信されました',
    'setSuccess': '設定しました',
    'delSuccess': '削除しました',
    'addSuccess': '追加されました',
    'fileType': 'ファイルを再選択してください。ファイルはxls、xlsx形式のみをサポートしています。',
    'fileSize': 'ファイルを再選択してください。ファイルサイズは15 MBを超えてはいけません！',
    'delError': '削除に失敗しました。しばらくしてからもう一度お試しください',
    'uploadFile': 'ファイルをアップロードしてください。',
    'uploadFileSuccess': 'アップロードに成功しました',
    'selectedOne': '通関情報または生年月日を少なくとも１つ入力してください',
    'imgTips1': '{imgType}形式で画像をアップロードしてください',
    'imgTips2': '1枚の画像が3MBを超えることはできません',
    'imgTips3': '1枚の画像が10MBを超えることはできません',
    'imgTips4': 'PDFファイルのプレビューは現在サポートされていません',
    'checkProduct': '製品を選択してください',
    'clauseAgree': '「電子運送状契約条項」に同意してください',
    'estimatedCost': '追加サービスフォームに見積り料金を入力してください',
    'cardCode': '追加サービスフォームに代金回収カード番号を入力してください',
    'threeTips': 'アイテム情報が完全ではありません、もう一度確認してください',
    'fourTips': '注文情報が完全ではありません。もう一度確認してください',
    'noNeedUpload': '身元確認書をアップロードする必要がありません。',
    'phoneOrFixAtLeastOne': '携帯電話番号、固定電話は少なくとも1つ記入してください',
    'customerOrderNo': '顧客注文番号を入力してください',
    'mas_003038': 'ログインアカウントに異常が発生しました。注文する前にページを更新してください。',
    'mas_003038_HTM': 'ログイン（携帯電話番号）に異常が発生しました。ページを更新して注文を試みてください。',
    'mas_003035': 'あなたのアカウントはすでに登録されていますので、IUOPから直接国際書類に登録してください。',
    'mas_auth_failed': '認証失敗'
  },
  'verify': {
    'selectAreaCode': '国番号を選択してください',
    'telTips': '携帯番号を入力してください',
    'telError': '有効な携帯番号を入力して下さい',
    'companyNameTrue': '正しい会社名を入力してください',
    'fixMobileCode': '固定電話番号を選択してください',
    'fixMobileNumber': '固定電話番号を入力してください',
    'fixMobileNumberReg': '正しい固定電話番号を入力してください',
    'mobileVerificationCode': '電話認証コードを入力してください',
    'emailAddress': 'メールアドレスを入力してください',
    'emailTips': '有効なメールアドレスを入力してください',
    'emailVerificationCode': 'メール認証コードを入力してください',
    'password': 'パスワードを入力してください',
    'passwordError': 'パスワードは8～20ビットで、大文字、数字、記号の3種類以上の組み合わせのみに対応しています',
    'passwordAgain': 'もう一度パスワードを入力してください',
    'passwordNotSame': 'パスワードが一致していません。もう一度入力してください',
    'usernameTips': 'ユーザー名を入力してください',
    'usernameEmailTips': 'ユーザー名/メールアドレスを入力してください',
    'telEmailTips': '携帯電話番号(国番号不要)/メールアドレスを入力してください',
    'fixTelEmailTips': '正しい携帯電話番号(国番号不要)/メールアドレスを入力してください',
    'selectTerms': '利用規約を確認してチェックを入れてください',
    'accountName': 'ユーザー名は、文字で始まる6〜20文字のみ設定可能で、文字、数字、およびアンダーバーを含めることができます',
    'verifyType': '認証方法を選択してください',
    'verifyCode': '请输入验证码',
    'lastNameRequired': '姓は空欄にすることはできません',
    'firstNameRequired': '名は空欄にすることはできません',
    'genderRequired': '性別を空欄にすることはできません',
    'birthdayRequired': '生年月日をご入力ください',
    'certTypeRequired': '身元確認書の種類を空欄にすることはできません',
    'certNoRequired': '身元確認書のID番号を空欄にすることはできません',
    'certExpireDateRequired': '身元確認書の有効期間を空欄にすることはできません',
    'notSupTips': '数字やその他の特殊文字はサポートされていません',
    'certImage': '送信する前に身分証明書の写真をアップロードしてください',
    'commodityName': 'アイテムを入力してください。',
    'quantity': '数量を入力してください。',
    'unit': '単位を選択してください',
    'unitPrice': '単価を入力してください。',
    'placeOfOrigin': '原産国を選択してください',
    'over0': '0より大きい数値を入力してください',
    'decimal3': '小数点6位まで入力可能です',
    'decimal6': '小数点6位まで入力可能です',
    'decimal10': '小数点10位まで入力可能です',
    'productRecordNo': '正しい国家検査記録番号をご入力ください',
    'hsCode': '正しい税関コードをご入力ください',
    'productCustomsNo': '正しい税関登録番号をご入力ください。',
    'contact': '名前を入力してください',
    'companyName': '会社名を入力してください',
    'country': '国/地域を選択してください',
    'regionFirst': '都道府県を選択してください',
    'roadName': '番地を入力してください',
    'buildingNumber': '建物の番号を入力してください。',
    'addressDetail': '詳細な住所を入力してください',
    'addressDetailTrue': '正しい詳細な住所をご入力ください',
    'postalCode': '郵便番号を入力してください',
    'phoneNumber': '携帯番号を入力してください',
    'numberDecimal': '数字を入力してください',
    'bangmecho': '番地を入力してください',
    'shippingType': '荷送人種類を選択してください',
    'clearanceInfo': '身元確認書類の種類を選択してください',
    'idNumber': '法人統一番号をご入力ください',
    'idNumberIsTrue': '正しいID番号を入力してください。',
    'contactCn': '正しい中国語名を入力してください',
    'receiveType': '荷受人種類を選択してください',
    'imgNumber': '少なくとも{number}枚の写真をアップロードする',
    'papersTime': '身元確認書の有効時間を選択してください',
    'declaredCurrency': '通貨を選択してください',
    'requred': 'この項目は必須項目です',
    'parcelTotalWeight': '総重量を入力してください。',
    'contentMaxLength18': 'コンテンツの長さは1〜18です',
    'contentIntOrFloatMaxLength': '最大12の整数と小数点10位までサポートします',
    'atLeastSelectTip': '少なくともつのレコードを選択してください',
    'invitationCode': '有効な招待コードを入力してください',
    'characterLength': '長さが{length}文字を超えてはいけません',
    'pickUpTime': '予約の集荷時間を選択してください',
    'onlyNumberAndLetter': '英数字の組み合わせのみが入力可能です',
    'serviceFee': '付加サービスの推定料金は、12ビット整数、2ビット小数点以下をサポートすることができます。',
    'methoedCode': '追加サービスの代引きカード番号は最大20桁をサポートしまです',
    'contentInt14OrFloat2MaxLength': '最大14桁の整数と小数点2位までが入力可能です',
    'contentInt10OrFloat6MaxLength': '最大10桁の整数と小数点6位までが入力可能です',
    'contentInt18OrFloat6MaxLength': '最大18桁の整数と小数6桁点第六位までが入力可能です',
    'timeZoneCode': 'タイムゾーンを選択してください',
    'contentInt14OrFloat1MaxLength': '最大14桁の整数と小数点1位までが入力可能です',
    'contentInt15OrFloat5MaxLength': '最大15桁の整数と小数点5位までが入力可能です'
  },
  'placeholder': {
    'countryCode': '国番号を選択してください',
    'telCode': '国番号',
    'phoneCode': '携帯番号を入力してください',
    'mobileVerificationCode': '電話認証コードを入力してください',
    'verificationCode': '認証コードを入力してください',
    'emailAddress': 'メールアドレスを入力してください',
    'emailVerificationCode': 'メール認証コード',
    'password': 'パスワードを入力してください',
    'checkPassword': 'もう一度パスワードを入力してください',
    'enter': '入力してください',
    'username': 'ユーザー名は、ログインするために使用することができます',
    'cardType': '身元確認書類の種類を選択してください',
    'uploadCard': '身元確認書と一致している必要があります',
    'uploadCardId': '有効なID番号を入力してください。',
    'passwordError': 'パスワードは8〜20桁で、大文字と小文字、数字、記号の2つ以上の組み合わせのみが可能です',
    'passwordAgain': 'もう一度パスワードを入力してください',
    'verifyType': '認証方法を選択してください',
    'newEmail': 'メールアドレスを入力してください',
    'addressBook': 'お氏名/社名のクエリを入力してください。',
    'goodsWarehouse': 'アイテム名/税関コードを入力してください。',
    'clearanceWaybill': '12桁の数字の運送状番号または SF 先頭の15桁の運送状番号を入力してください',
    'parcelTotalLength': '長さを入力してください',
    'parcelTotalWidth': '幅を入力してください',
    'parcelTotalHeight': '高さを入力してください',
    'senderReason': '輸出理由を選択してください',
    'tradeCondition': '取引条件を選択してください',
    'senderReasonContent': '非商用の輸送の理由を記入してください',
    'businessRemark': '商用請求書コマーシャルインボイスの備考欄にご記入ください',
    'pickupAppointTime': '日時を選択してください（集荷時間は予約から3時間以内です）',
    'remarkText': '手動でテキストを入力することができます',
    'payMethod': 'お支払方法を選択してください',
    'payMonthCard': 'SFアカウントを入力してください',
    'taxPayMethod': '税金の支払い方法を選択してください',
    'taxPayMonthCard': '税金の決済口座を入力してください',
    'serviceFee': '推定コストを入力してください。',
    'feeCard': 'CODカード番号の代金回収を入力してください。',
    'invitationCode': 'あなたの登録/ VIPの招待コードを入力してください',
    'willBay': '追跡番号を入力してください。',
    'senderCountry': '発送元を選択してください',
    'receiverCountry': '仕向地を選択してください',
    'receiverContact': '荷受人名前を入力してください。',
    'orderStatus': 'オーダーステータスを選択してください',
    'startTime': '開始日',
    'to': '~',
    'endTime': '終了日',
    'timeZoneCode': 'タイムゾーンを選択してください'
  },
  'tagsView': {
    'refresh': 'リフレッシュ',
    'close': 'クローズ',
    'closeOthers': 'その他を閉じます',
    'closeAll': 'すべて閉じます'
  },
  'exit': {
    'title': 'サインアウト',
    'message': 'ログアウトしますか？',
    'success': '退出成功',
    'cancel': '退出取消',
    'close': 'ログアウトに成功'
  },
  'notFind': {
    'oops': '404',
    'info': '申し訳ありませんが、アクセスしたページは存在しません',
    'backHome': 'ホームページに戻ります'
  },
  'settings': {
    'title': '国際認証サービスセンター（ICAS）'
  },
  'role': {
    'admin': '管理者',
    'user': '一般ユーザ'
  },
  'route': {
    'Login': 'ログイン＃ログイン＃',
    '顺丰国际产品导航': 'Product Navigation',
    'Register': '登録',
    'ResetPassword': 'パスワードをお忘れですか？',
    'UserCenter': 'パーソナルセンタープロフィール',
    'MyInfomation': 'マイページ',
    'AccountInfomation': 'アカウント情報',
    'BaseInfomation': '基本情報',
    'AccountSecurity': 'アカウントセキュリティ',
    'ProtocolManage': '署名管理',
    'BindingEmail': 'メールアドレスで紐付ける',
    'BindingPhone': '携帯番号で紐付ける',
    'CancelAccount': 'アカウントを削除する',
    'AccountSetting': 'アカウント設定',
    'ChangeEmail': 'メールアドレスを変更します。',
    'ChangePassword': 'パスワードの変更',
    'ChangePhone': '携帯番号を変更する',
    'Name': 'ユーザー名を設定する',
    'ToMail': '荷物を送る',
    'MailProduct': 'サービス',
    'AddressBook': 'アドレス帳',
    'GoodsWarehouse': '物品保管庫',
    'Order': 'オーダー管理',
    'OrderIndex': 'オーダーリスト',
    'OrderAdd': 'オーダーする',
    'Clearance': '通関情報',
    'UploadPhotoid': '身元確認書のアップロード',
    'EditOrder': 'オーダーの編集',
    'permission': '権限管理',
    'permission_system': 'システム管理',
    'permission_role': 'ロール管理',
    'permission_resource': 'リソース権限',
    'permission_user': 'ユーザー管理'
  },
  'button': {
    'sumbit': '提出'
  },
  'accountInfo': {
    'username': 'ユーザー名：',
    'firstname': '名：',
    'lastname': '姓：',
    'sex': '性別：',
    'man': '男性',
    'woman': '女性',
    'telNumber': '携帯番号:',
    'telNumberNot': 'アカウントは携帯番号に紐付けされていません',
    'email': 'メールアドレス',
    'emailNot': 'アカウントはメールに紐付けされていません',
    'binding': 'すぐに紐付ける',
    'changeTel': '携帯番号を変更する',
    'changeEmail': 'メールアドレスを変更します。',
    'validated': '認証済み',
    'autoGeneration': '自動生成',
    'usernameTips': 'ユーザー名を設定した後に変更することはできません',
    'birthday': '生年月日：',
    'birthday1': '生年月日',
    'autoCreate': '自動生成'
  },
  'baseInfo': {
    'cardType': '身元確認書の種類：',
    'firstname': '名：',
    'lastname': '姓：',
    'cardId': 'ID番号：',
    'cardTime': '有効期間：',
    'cardImg': '証明書の画像：',
    'cardLangTime': '永久に有効',
    'uploadImg': '画像アップロード',
    'titleTips': '注意：国は商品を送るためのに実名システムを実装しており、が必要であり通関に使用されます。身元確認書には通関用の特別な透かしが設定されます。SFはお客様の情報のセキュリティを確保します。',
    'dialogTitle': '標準的な例',
    'dialogTips': 'アップロードされたID写真の四隅は無傷で、テキストは鮮明で、反射や障害物はありあってはいけません。ぼやけているか暗すぎると、認証が失敗する可能性があります。',
    'cardUp': '身元確認書表面',
    'cardDown': '身元確認書裏面'
  },
  'emailLink': {
    'tips': 'アカウントのパスワードを設定してください',
    'setPassword': 'パスワードを設定してください',
    'success': 'アカウントがアクティブ化されました'
  },
  'accountSecurity': {
    'ChangePassword': 'パスワードの変更',
    'ChangePasswordDesc': '長期間ログインしておらず、パスワードを忘れた場合は、本人確認後にパスワードを変更することができます。',
    'BindingPhone': '携帯番号で紐付ける',
    'BindingPhoneDesc': '紐づけられた携帯電話は、携帯電話のログイン、パスワードの取得、オーダー、その他のサービスに使用できます。',
    'BindingEmail': 'メールアドレスで紐付ける',
    'BindingEmailDesc': '紐づけられたメールボックスアドレスは、メールボックスのログイン、パスワードの取得、オーダー、その他のサービスに使用できます。',
    'SettingName': 'ユーザー名の設定',
    'SettingNameDesc': 'ユーザー名はログインIDとして使用され、変更できかねます。',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealName': 'Set First name&Last name	',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'immediatelySet': '設定する',
    'alreadySet': '既に設定されています',
    'settingComplete': 'セットアップが完了しました',
    'alreadyBinding': '既に紐付けられています',
    'userName': 'ユーザー名',
    'userNameLogin': 'ユーザー名ログイン',
    'selfCreate': '自動生成',
    'stopEdit': 'ユーザー名のセットの後に変更することはできません',
    'setOk': '設定完了',
    'cancelAccount': 'アカウントを解除する',
    'cancelAccountTips': '解除後はデータを復元できませんのでご注意ください',
    'toCancel': 'すぐに解除する',
    'cancelToKnow': 'アカウント解除のお知られ',
    'cancelDesc1': '1.このアカウントはSFインターナショナルの統合アカウントです。SFインターナショナル関連プラットフォームで登録解除を申請すると、登録解除されたアカウントはSFインターナショナルのプラットフォームで使用または復元できなくなります。登録解除する前にアカウント情報とデータをバックアップしてください',
    'cancelDesc2': '2.登録解除を申請するということは、アカウントのすべてのメ会員権益と仮想資産（会員ポイント、会員等級と会員権益、クーポンなどを含むが、これらに限定されない）を自発的に放棄することを意味します。',
    'cancelDesc3': '3.登録解除した後は、このアカウントを使用できなくなります。また、ユーザー名、アイコンなどアカウントと関連する情報を取得することもできなくなります。 （送り状情報は、プライバシーポリシーの保存に規定されている期限に従います。送り状番号でSFウェブサイトで荷物の追跡を確認できます）。',
    'cancelDesc4': '4.SFアカウントをお持ちする場合、解除後、このアカウントはSFアカウントの紐付けが解除されます。引き続きSFアカウントをご利用になる場合は、再度新しいアカウントを紐付けしてください。',
    'cancelDesc5': '5.本アカウントを解除することは、本アカウント以前の行為と関連責任が免除または軽減されたことを意味するものではありません',
    'cancelDesc6': '6.この解除申請は、15日以内に取り消すことができます。解除申請した日から15日以内に再度ログインすると、アカウントを自動的に解除申請をキャンセルされます。',
    'cancelAgree': '読んで同意しました',
    'cancelTitle': 'アカウントの登録解除',
    'cancelConfirm': 'アカウントを解除しますか？',
    'cancelTips': 'アカウントの解除通知をお読みの上、同意してください',
    'goBinding': 'すぐに紐付ける',
    'changeBinding': 'すぐに紐付けデバイスを変更する',
    'auth': '認証',
    'finish': '変更が完了しています',
    'binding': '紐付け完了',
    'verifyType': '認証方式',
    'ChangePhone': '携帯番号を変更する',
    'ChangeEmail': 'メールアドレスを変更します。',
    'tips1': 'パスワードが変更しされました',
    'tips2': '携帯番号が変更されました',
    'tips3': 'メールボックスアドレスが変更しされました',
    'tips4': '携帯番号が紐付けされました',
    'tips5': 'メールアドレスが紐付けが成功しされました',
    'tips6': 'ユーザー名のが設定が成功しされました'
  },
  'accountConflict': {
    'title': 'アカウント情報の確認',
    'desc1': 'こんにちは',
    'desc2': 'このメールアドレス/携帯電話が弊社の複数のシステムに登録されていることを検出しました。</br>サービスを向上させるため、複数のシステムの一括ログインできるアカウントを1つ選択し使ってください。',
    'desc3': '「確認」をクリックすると、メールアドレス/携帯電話にパスワード変更のリンクを送信されます。 指示に従って操作してください。',
    'loginName': 'お名前',
    'phone': '携帯電話',
    'registerSys': '登録システム',
    'registerTime': '登録時間',
    'newRegister': '新規登録',
    'infoVer': '情報を認証する。',
    'inforVerSelect': '認証方法を選んでください。',
    'selectOne': '1つのアカウントを選んで、ログインしてください。',
    'IBS': '海外集荷依頼プラットフォーム',
    'ICAS': '国際統一アカウント管理プラットフォーム',
    'IUOP': '国際統一注文プラットフォーム',
    'IBSE': '国際商社物流輸出',
    'PMS': '国際商社物流輸出',
    'IBSI': '国際業者の物流輸入',
    'SFBUY': 'SFBUY',
    'POP': 'パートナーオープンプラットフォーム',
    'SFGOAPP': 'SF アプリ',
    'IFTP': '国際ヘビー　フレートプラットフォーム',
    'OFTP': '海外貨物輸送プラットフォーム'
  },
  'permission': {
    'reset': 'リセット',
    'enable': '有効化',
    'disable': '無効化',
    'delete': '削除＃サクジョ＃',
    'deleteBatch': '一括削除',
    'remark': '備考',
    'sort': 'ソート＃ソート＃',
    'confirm': '確認',
    'cancel': 'キャンセル',
    'operation': '操作',
    'modify': '変更',
    'select': '選択してください',
    'input': 'ユーザー名または番号を入力してください',
    'query': 'クエリー＃クエリー＃',
    'edit': '編集',
    'required_rule': 'データを空にすることはできません',
    'success': '操作が成功しました',
    'fail': '操作に失敗しました',
    'length_rule': '文字数{min}から{max}までの長さ',
    'deleteTip1': '最初に「{name}」の下のすべてのサブシステムを無効にしてください',
    'deleteTis': '名前が「{name}」のデータアイテムの削除を確認しますか？',
    'deleteChildTis': '同時にこのシステム下のすべてのシステムが削除されます',
    'tis': 'ヒント',
    'deleteBatchTis': '選択した{num}エントリデータの削除を確認しますか？',
    'enableTis': '{statusName}で選択された{num}バーのデータを確認しますか？',
    'msgError': '操作データに誤りがある',
    'codeCheckRule': '大文字と小文字、数字、「_」または「-」を許可する',
    'checkMinCharacter': '以上の文字を入力してください',
    'roleType_0': 'カスタムロール',
    'roleType_1': 'システム管理者',
    'bindResource': 'リソースのバインド',
    'roleList': 'ロールのリスト',
    'roleAdd': '新しいロール',
    'roleEdit': 'ロールの編集',
    'roleConfig': 'ロールの設定',
    'childSystemName': 'サブシステム名',
    'roleNo': 'ロール番号',
    'roleName': 'ロール名',
    'roleDescribe': 'ロールの説明',
    'isSystem': '所属システム',
    'roleType': 'ロールタイプ',
    'userStatus_0': '非アクティブ',
    'userStatus_1': 'アクティブ化済み',
    'userStatus_2': '事前登録解除',
    'userStatus_3': 'ログオフ済み',
    'userStatus_4': '無効化',
    'userStatus_5': 'ロック＃ロック＃',
    'userRoleEdit': 'ロールの表示/編集',
    'userList': 'ユーザーリスト',
    'regtime': '登録時間',
    'userCode': 'ユーザー番号',
    'area': '所属地域',
    'nickName': 'ニックネーム',
    'sourceSystem': 'ソースシステム',
    'userStatus': 'スターテス',
    'systemList': 'システムリスト',
    'systemAdd': '新しいシステム',
    'systemModify': 'システムの変更',
    'systemName': 'システム名',
    'systemType': 'システムタイプ',
    'systemType_0': 'マスタデータ',
    'systemType_1': 'ビジネスシステム',
    'systemCode': 'システムコーディング',
    'systemStatus': 'システム状態',
    'systemStatus_0': '有効化',
    'systemStatus_1': '無効化',
    'systemAddChildren': '新しいサブシステム',
    'systemSuperior': '上位システム',
    'resourceList': 'リソースリスト',
    'resourceAdd': '新規リソース',
    'resourceModify': 'リソースの変更',
    'resourceName': 'リソース名',
    'resourceType': 'リソースタイプ',
    'resourceType_MENU': 'メニュー',
    'resourceType_MODULE': 'ディレクトリ',
    'resourceType_WIDGET': 'ボタンを使用します。',
    'resourceCode': 'リソースコーディング',
    'resourceStatus': 'リソースステータス',
    'resourceStatus_true': '有効化',
    'resourceStatus_false': '無効化',
    'resourceAddChildren': '新規サブアイテム',
    'resourceSuperior': '親メニュー',
    'icon': 'アイコンスタイル',
    'iconActive': 'アクティブアイコン',
    'shortName': '略称',
    'resourceUrl': 'リソースURL',
    'resourceFun': '機能URL',
    'openType': '開く方法',
    'openType_0': 'ページルーティング',
    'openType_1': '新しいウィンドウ',
    'pub': '権限制御が必要かどうか',
    'pub_true': 'はい',
    'pub_false': 'いいえ',
    'hidden': '非表示にするかどうか',
    'hidden_0': 'はい',
    'hidden_1': 'いいえ',
    'selectSystem': 'まずシステムを選択してください'
  },
  'protocol': {
    'num': '番号付け',
    'protocolName': 'プロトコル名',
    'protocolNo': 'プロトコルバージョン番号',
    'signTime': '署名時間',
    'remark': '備考',
    'signUser': 'アカウントの署名',
    'signName': '顧客名の署名',
    'signChild': 'プロトコルサブバージョン番号'
  },
  'sfbuy': {
    'wechatScane': '微信スキャン',
    'wechatScane1': 'タイムリーに把握する',
    'wechatScane2': 'ウィーチャット動態',
    'onlineService': 'オンラインカスタマーサービス',
    'aboutUs': '私たちについて',
    'serviceGuide': '初心者向けガイド',
    'helpCenter': 'ヘルプセンター',
    'serviceAndPrice': 'サービスと価格',
    'announcement': '公告',
    'important': '重要'
  },
  messageNotice: {
    'yxDetail': '詳細',
    'optional': '選択可能',
    'loginXyAgree': 'マーケティングや広告の通知を受け取ることに同意します',
    messageNotice: '通知メッセージ',
    messageNoticeDesc: '通知設定の変更対応',
    messageNoticeBtn: '構成の変更',
    messageNoticeTitle: 'マーケティング通知設定',
    messageNoticeTitleDesc1: '個人情報収集の',
    messageNoticeTitleDesc2: ',はこちら、チェックでマーケティング広告の受信同意',
    messageNoticeDetailTitle: 'マーケティング通知情報詳細',
    message: 'SMS',
    messageNotcieDialogTitle: 'マーケティングチャネル設定',
    considerLater: '後で検討します',
    messageNotcieDialogDesc1:
    '確認ボタンをクリックすることにより、あなたは以下のチャネルを通じて興味を持つ可能性のあるマーケティングや広告の送信に同意したものとします。個人情報の収集に関する詳細は',
    messageNotcieDialogDesc2: 'をご覧ください。',
    messageNotcieDialogDetail: '詳細',
  },
  weakPassword: {
    提示: 'ヒント',
    账号异常提醒: 'アカウントに異常があります。パスワードを変更するか、認証コード・QRコードでログインしてください。',
    修改密码: 'パスワード変更',
    关闭: '閉じる',
    账号异常处理: 'アカウント異常処理',
    绑定提示: 'まず携帯電話またはメールを登録し、パスワードを変更してください',
    账号: 'アカウント'
  },
  recommendedPassword: {
    使用推荐密码: '推奨パスワードを使用',
    提示: 'ご注意',
    请保管好您的密码: 'パスワードは大切に保管してください。ログイン後、速やかに変更することをお勧めします。',
    复制密码: 'パスワードをコピー',
    psd: 'パスワード',
    copySuccess: 'コピー成功',
    注册成功: '登録成功、おめでとうございます！',
    注册建议: `アカウントの安全を確保するため、「管理センター - アカウント設定」にてパスワードの変更をおすすめします。`,
    修改密码: ''
  },
  twoFactorAuth: {
    双因素认证: '二要素認証',
    认证方式: '認証方法 (にんしょうほうほう)',
    为了您的账号安全: 'お客様のアカウントを保護するため、二要素認証を完了してからログインしてください。',
    请选择绑定: '選択してバインドしてください:',
    请先设置您的密码: 'まずパスワードを設定してください'
  },

  sendType: {
    您当前手机区号不支持whatsapp: '現在の携帯電話の市外局番は{noticeChanel}に対応していません。他の認証コード取得方法を選択してください',
    请使用绑定手机号接收验证码: '登録済みの電話番号を使用して認証コードを受信してください',
    请使用绑定邮箱接收验证码: '登録済みのメールアドレスを使用して認証コードを受信してください',
    请选择验证码接收方式: '認証コードの受信方法を選択してください'
  },

  recommendFloat: {
    '满意度评价': '満足度評価',
    '您的评价对我们很重要': 'ご意見は私たちにとって非常に重要です',
    '我要评价': '評価したいです'
  }
}
